import React from 'react';

import { Icon } from '../Icon/Icon';
import { COLORS } from '../../theme/tokens';
import { Root } from './DrillChevron.styles';

/**
 * Decorative drill-in chevron for list cards. Not interactive on its own —
 * `aria-hidden` so it isn't announced; the parent card owns any click.
 */
export const DrillChevron = (): React.ReactElement => (
  <Root aria-hidden>
    <Icon name="arrow-right-circle" size={22} color={COLORS.icon} />
  </Root>
);

export default DrillChevron;
